import SearchBar from './SearchBar';
import PanelControlButtons from './PanelControlButtons';

const GlobalSearchHeader = ({
  onSearch,
  defaultSearchValue,
  drawerMode,
  placeholder,
  showRightControls = true,
}) => {
  if (!drawerMode) {
    return (
      <div className="grid grid-cols-[328px_minmax(0,1fr)_328px] items-center mb-4 w-full gap-6 min-w-0">
        <div className="min-w-0" />
        <div className="min-w-0 flex justify-center">
          <div className="w-full max-w-[636px] min-w-0">
            <SearchBar
              className="search-bar !w-full !mx-0 !my-0"
              onSearch={onSearch}
              placeholder={placeholder || '搜索探索内容...'}
              defaultValue={defaultSearchValue}
            />
          </div>
        </div>
        <div className="w-[328px] flex-shrink-0 flex justify-end">
          <PanelControlButtons />
        </div>
      </div>
    );
  }

  if (!showRightControls) {
    return (
      <div className="mb-4 w-full min-w-0">
        <div className="w-full max-w-[636px] min-w-0 mx-auto">
          <SearchBar
            className="search-bar !w-full !mx-0 !my-0"
            onSearch={onSearch}
            placeholder={placeholder || '搜索探索内容...'}
            defaultValue={defaultSearchValue}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="flex gap-6 items-center mb-4 w-full min-w-0">
      <div className="flex-1 min-w-0 flex justify-center">
        <div className="w-full max-w-[636px] min-w-0">
          <SearchBar
            className="search-bar !w-full !mx-0 !my-0"
            onSearch={onSearch}
            placeholder={placeholder || '搜索探索内容...'}
            defaultValue={defaultSearchValue}
          />
        </div>
      </div>
      <div className={`${drawerMode ? 'flex-shrink-0' : 'w-[328px] flex-shrink-0'} flex justify-end`}>
        <PanelControlButtons />
      </div>
    </div>
  );
};

export default GlobalSearchHeader;
